/**
 * CFP franc.
 */
export var XPF = {
  code: 'XPF',
  base: 10,
  exponent: 0
};